import { render, staticRenderFns } from "./StartStep.vue?vue&type=template&id=037248a2"
import script from "./StartStep.vue?vue&type=script&lang=ts"
export * from "./StartStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports